// Account API
import ajax from './_ajax';

const baseUrl = '/api/account';
const api = {};
api.login = function (params) {
  return ajax.post(baseUrl + '/login', params);
};

api.logout = function () {
  return ajax.post(baseUrl + '/logout');
};

api.register = function (params) {
  return ajax.post(baseUrl + '/register', params);
};

api.resetPassword = function (params) {
  return ajax.post(baseUrl + '/resetPassword', params);
};

api.getCountryCode = function () {
  return ajax.get(baseUrl + '/getCountryCode');
};
// 修改手机号
api.changePhoneNo = function (params) {
  return ajax.post('/api/Account/ChangePhoneNo', params);
};
// 修改密码
api.changePassword = function (params) {
  return ajax.post('/api/Account/ChangePassword', params);
};
// 修改邮箱
api.changeEmail = function (params) {
  return ajax.post('/api/Account/ChangeEmail', params);
};
// 重置密码
api.resetPassword = function (params) {
  return ajax.post('/api/account/ResetPassword', params);
};
api.resetPasswordByPhoneNo = function (params) {
  return ajax.post('/api/Account/ResetPasswordByPhoneNo', params);
};

export default api;



// WEBPACK FOOTER //
// ./src/api/accountApi.js